"use client"

import React from "react"
import { useEffect, useState } from "react"
import { Typography } from "@mui/material"


const AnimatedCounter = ({ value, duration = 1.5, variant = "h4", sx = {} }) => {
  const [displayValue, setDisplayValue] = useState(0)

  useEffect(() => {
    let startTime
    let animationFrame

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp
      const progress = Math.min((timestamp - startTime) / (duration * 1000), 1)

      const easeOutQuart = 1 - Math.pow(1 - progress, 4)
      const currentValue = Math.floor(easeOutQuart * value)

      setDisplayValue(currentValue)

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate)
      }
    }

    animationFrame = requestAnimationFrame(animate)

    return () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame)
      }
    }
  }, [value, duration])

  return (
    <Typography variant={variant} sx={sx}>
      {displayValue.toLocaleString()}
    </Typography>
  )
}

export default AnimatedCounter